import { get } from "lodash";

export const shouldShowMonthlySub = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodMonthly")) ||
      (Boolean(get(data, "covenants.borrowerListOfDocsMonthly")) && get(data, "covenants.borrowerListOfDocsMonthly").length > 0) ||
      Boolean(get(data, "covenants.borrowerDocsMonthlyReportingStart"));

export const shouldShowQuarterlySub = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodQuarterly")) ||
      (Boolean(get(data, "covenants.borrowerListOfDocsQuarterly")) && get(data, "covenants.borrowerListOfDocsQuarterly").length > 0) ||
      Boolean(get(data, "covenants.borrowerDocsQuarterlyReportingStart"));

export const shouldShowSemiAnnuallySub = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodSemiAnnually")) ||
      (Boolean(get(data, "covenants.borrowerListOfDocsSemiAnnually")) && get(data, "covenants.borrowerListOfDocsSemiAnnually").length > 0) ||
      Boolean(get(data, "covenants.borrowerDocsSemiAnnuallyReportingStart"));

export const shouldShowAnnuallySub = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodAnnually")) ||
      (Boolean(get(data, "covenants.borrowerListOfDocsAnnually")) && get(data, "covenants.borrowerListOfDocsAnnually").length > 0) ||
      Boolean(get(data, "covenants.borrowerDocsAnnuallyReportingStart"));

export const shouldShowBorrowerDeliveryPeriodMonthly = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodMonthly"));

export const shouldShowBorrowerDeliveryPeriodQuarterly = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodQuarterly"));

export const shouldShowBorrowerDeliveryPeriodSemiAnnually = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodSemiAnnually"));

export const shouldShowBorrowerDeliveryPeriodAnnually = data => Boolean(get(data, "covenants.borrowerDeliveryPeriodAnnually"));

export const shouldShowListOfDocsMonthly = data => {
  const docs = get(data, "covenants.borrowerListOfDocsMonthly");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsQuarterly = data => {
  const docs = get(data, "covenants.borrowerListOfDocsQuarterly");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsSemiAnnually = data => {
  const docs = get(data, "covenants.borrowerListOfDocsSemiAnnually");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowListOfDocsAnnually = data => {
  const docs = get(data, "covenants.borrowerListOfDocsAnnually");

  return Boolean(docs) && docs.length > 0;
};

export const shouldShowBorrowerDocsMonthly = data => Boolean(get(data, "covenants.borrowerDocsMonthlyReportingStart"));

export const shouldShowBorrowerDocsQuarterly = data => Boolean(get(data, "covenants.borrowerDocsQuarterlyReportingStart"));

export const shouldShowBorrowerDocsSemiAnnually = data => Boolean(get(data, "covenants.borrowerDocsSemiAnnuallyReportingStart"));

export const shouldShowBorrowerDocsAnnually = data => Boolean(get(data, "covenants.borrowerDocsAnnuallyReportingStart"));

export const shouldShowBorrowerOfficerCertificate = data => Boolean(get(data, "covenants.borrowerOfficerCertificate"));

export const shouldShowSignor = data => get(data, "covenants.borrowerOfficerCertificate");
